<template>
  <f7-page name="notifications">
    <bc-navbar></bc-navbar>
    <div id="pages_maincontent">
      <a v-on:click="back">
        <img src="/static/images/icons/black/back.png" alt="" style="margin-left:20px;" class="back_image_button"
          title="">
      </a>
      <div v-show="isRequestActive" class="loader">
        <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
      </div>
      <h2 class="page_title">NOTIFICATIONS</h2>
      <div class="page_single layout_fullwidth_padding">
        <div class="contactform">
          <label>Notify Me When...</label>
          <form>

            <div class="form_row">
              <label>I get a message from {{salesPersonFullName}}</label>
              <div class="form_row_right">
                <label class="label-checkbox item-content">
                  <!-- Checked by default -->
                  <input type="checkbox" name="message-checkbox" :disabled="!customerUser.mobilePhone"
                    v-model="model.companyMessageSms" :checked="model.companyMessageSms">
                  <div class="item-media">
                    <i v-bind:class="{ 'disabled': !customerUser.mobilePhone}" class="icon icon-form-checkbox"></i>
                  </div>
                  <div class="item-inner">
                    <div class="item-title" v-bind:class="{ 'disabled': !customerUser.mobilePhone}">SMS</div>
                  </div>
                </label>
              </div>
            </div>
            <div class="form_row">
              <label>The person that I sent "Share My App" registers their app</label>
              <div class="form_row_right">
                <label class="label-checkbox item-content">
                  <!-- Checked by default -->
                  <input type="checkbox" name="share-checkbox" :disabled="!customerUser.mobilePhone"
                    v-model="model.sharedAppSms" :checked="model.sharedAppSms">
                  <div class="item-media">
                    <i v-bind:class="{ 'disabled': !customerUser.mobilePhone}" class="icon  icon-form-checkbox"></i>
                  </div>
                  <div class="item-inner">
                    <div class="item-title" v-bind:class="{ 'disabled': !customerUser.mobilePhone}">SMS</div>
                  </div>
                </label>

                <label class="label-checkbox item-content">
                  <input type="checkbox" name="share-checkbox" :disabled="!customerUser.email"
                    v-model="model.sharedAppEmail" :checked="model.sharedAppEmail">
                  <div class="item-media">
                    <i v-bind:class="{ 'disabled': !customerUser.email }" class="icon icon-form-checkbox"></i>
                  </div>
                  <div class="item-inner">
                    <div class="item-title" v-bind:class="{ 'disabled': !customerUser.email }">Email</div>
                  </div>
                </label>
              </div>
            </div>
            <!--<div v-if="false" class="form_row">
                        <label>The person that I referred purchased from {{customerUser.salesPersonFullName}}</label>
                        <div class="form_row_right">
                          <label class="label-checkbox item-content"> 
                            <input type="checkbox" name="purchased-checkbox" :disabled="customerUser.isOptIn===false"  v-model="model.purchasedSms" :checked="model.purchasedSms">
                            <div class="item-media">
                              <i class="icon icon-form-checkbox"></i>
                            </div>
                            <div class="item-inner">
                              <div v-bind:class="{ 'disabled': customerUser.isOptIn === false }" class="item-title">SMS</div>
                            </div>
                          </label>
        
                          <label class="label-checkbox item-content">
                            <input type="checkbox" name="purchased-checkbox"  v-model="model.purchasedEmail" :checked="model.purchasedEmail">
                            <div class="item-media">
                              <i class="icon icon-form-checkbox"></i>
                            </div>
                            <div class="item-inner">
                              <div class="item-title">Email</div>
                            </div>
                          </label>
                       </div>   
                </div> -->
            <input type="button" class="form_submit" value="SAVE" v-if="!saveRequest.isActive" @click='submit'
              :style="borderStyle">

            <div v-if="saveRequest.isActive" class="loader">
              <looping-rhombuses-spinner v-if="!saveRequest.isSuccess" :animation-duration="2500" :rhombus-size="15"
                :style="{ 'color': customization.mainColor }" />
              <div class="success_msg" v-if="saveRequest.isSuccess">
                <img src="/static/images/icons/black/success.png" alt="" class="success_icon" title="">
                <div style="margin-left: 10px;">Changes saved!</div>
              </div>
            </div>

          </form>
        </div>

      </div>

    </div>
  </f7-page>
</template>
<script>
  /* eslint-disable */
  import {
    Request
  } from '../shared/base.requests'
  import {
    mapState
  } from 'vuex'
  import config from '../../config/customer.api'
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import {appInsights} from '../shared/applicationInsights'


  export default {
    name: 'Notifications',
    components: {
      LoopingRhombusesSpinner
    },
    mounted: function () {
      return new Promise((resolve, reject) => {
        Request.GetFromCache(config.getNotificationsSettings, function (json) {
          this.model = json
        }.bind(this))
        Request.get(config.getNotificationsSettings)
          .then(response => {
            this.model = response
            resolve()
          })
          .catch((error) => {
          appInsights.trackException({ exception: error.status, message: error.statusText, properties:  { 'apiUrl': config.getNotificationsSettings, 'accessId': localStorage.accessId}});
          appInsights.flush();
            console.error('get Notifications data failed', error)
            reject()
            this.$f7.mainView.router.load({
              url: 'error'
            })
          })
      })
    },
    computed: {
      ...mapState({
        customerUser: state => state.editUserProfile.customerUser,
        salesPersonFullName: state => state.common.salesPersonFullName,
        customization: state => state.common.customization
      }),
      borderStyle: function () {
        var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
        var backgroundStyle = this.customization.mainColor
        var colorStyle = this.customization.fontColor
        return {
          border: borderStyle,
          background: backgroundStyle,
          color: colorStyle
        }
      }
    },
    methods: {
      submit() {
        this.saveRequest.isActive = true
        this.saveRequest.isSuccess = false
        return new Promise(function (resolve, reject) {
          Request.post(config.saveNotificationsSettings, this.model)
            .then(function () {
              this.saveRequest.isSuccess = true
              setTimeout(function () {
                this.saveRequest.isActive = false
              }.bind(this), 1500)
            }.bind(this))
            .catch((error) => {
              appInsights.trackException({ exception: error.status, message: error.statusText, properties:  { 'apiUrl': config.saveNotificationsSettings,'data': this.model, 'accessId': localStorage.accessId}});
              appInsights.flush();
              console.error(error)
              this.isRequestActive = false
              this.$f7.mainView.router.load({
                url: 'error'
              })
            })
        }.bind(this))
      },
      back() {
        window.history.back()
      }
    },
    data() {
      return {
        model: {},
        isRequestActive: false,
        saveRequest: {
          isActive: false,
          isSuccess: false
        }
      }
    }
  }
</script>
<style scoped>
  .loader {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255, 255, 255);
    text-align: center;
    z-index: 100;
  }

  .looping-rhombuses-spinner {
    display: inline-block;
  }

  .success_icon {
    width: 30px;
    height: 30px;
    display: block;
  }

  .success_msg {
    display: flex;
    justify-content: space-around;
    align-content: center;
    margin-bottom: 20px;
  }

  .success_msg>* {
    margin: unset;
  }

  .none {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// notifications.vue?5af918cd